"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get default () {
        return getHandler;
    },
    get getConditionalHandler () {
        return getConditionalHandler;
    }
});
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function getHandler(defaultHandler, eeHandler) {
    return async (...args)=>{
        if (_Noco.default.isEE()) {
            return defaultHandler(...args);
        }
        return eeHandler(...args);
    };
}
function getConditionalHandler(defaultHandler, eeHandler) {
    return async (...args)=>{
        if (_Noco.default.isEE()) {
            return defaultHandler(...args);
        }
        return eeHandler(...args);
    };
}
